/* eslint-disable handle-callback-err */
import React, { useState, useRef } from 'react';
import TickIcon from '../../../util/icons/components/TickIcon';
import PropTypes from 'prop-types';

const JoinField = ({ error, handleChange, placeholder, testId }) => {
  const inputRef = useRef(null);
  const [ fieldUsed, setFieldUsed ] = useState(false);
  const [ focused, setFocused ] = useState(false);
  let wrapperClass = 'input-wrapper';
  let errorText = null;
  let tickClass = 'tick-radio';
  if (error && fieldUsed && focused === false) {
    wrapperClass += ' error';
    errorText = (
      <div className="error-feedback" data-cy={ testId + '-error' }>
        { error}
      </div>
    );
  }
  if (!error && fieldUsed) {
    tickClass += ' ticked';
  }
  const handleInputChange = () => {
    const val = inputRef.current.value;
    setFieldUsed(true);
    handleChange(val);
  };
  return (
    <div className={ wrapperClass }>
      <div className={ tickClass } ><TickIcon /></div>
      <input ref={ inputRef }
        onFocus={ () => setFocused(true) }
        onBlur={ () => setFocused(false) }
        placeholder={ placeholder }
        data-cy={ testId }
        onChange={ handleInputChange } />
      { errorText }
    </div>
  );
};

JoinField.propTypes = {
  error: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  testId: PropTypes.string
};

export default JoinField;
